export default {
  path: 'vehicle-tags',
  name: 'VehicleTags',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/VehicleTagsView.vue')
}
